import {selPropGen} from 'module/Properties/selector/selPropGen'
import {PropID} from 'module/Properties/enum/PropID'
import {propDefaultFalse, propDefaultTrue} from 'module/Properties/util/PropertiesUtil'

export const BookingUserConfigDict = {
	enabled: {
		label: 'Buchungen',
		type: 'boolean',
		defaultValue: false,
		defaultOverrideSelector: selPropGen(PropID.buchungDefault, propDefaultFalse),
		visibleSelector: selPropGen(PropID.buchungVis, propDefaultTrue),
	},
} as const

export const BookingUserConfigDefaultOnDict = {
	enabled: {
		label: 'Buchungen',
		type: 'boolean',
		defaultValue: true,
		defaultOverrideSelector: selPropGen(PropID.buchungDefault, propDefaultTrue),
		visibleSelector: selPropGen(PropID.buchungVis, propDefaultTrue),
	},
} as const